module.exports = __webpack_public_path__ + "img/rope_Lock_2.b3a2ad63.png";